// @ts-nocheck
import React, { useEffect, useState } from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  required,
  useNotify,
  useRedirect,
  useRefresh,
  SaveButton,
  Toolbar,
  SelectInput,
  BooleanInput,
  DateTimeInput,
  FormDataConsumer,
  Button,
  FileInput,
  FileField,
  downloadCSV,
  AutocompleteArrayInput,
  AutocompleteInput,
  // NumberInput
} from "react-admin";
import { makeStyles } from "@mui/styles";
import {
  Autocomplete,
  Box,
  Grid,
  IconButton,
  Paper,
  Stack,
  TextField as MuiTextField,
  Typography,
  Button as MuiButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { dataProvider } from "../../../provider";
import Swal from "sweetalert2";
import PostAddIcon from "@mui/icons-material/PostAdd";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import Papa from "papaparse";
import jsonExport from "jsonexport/dist";
import DescriptionIcon from "@mui/icons-material/Description";
import ReactJson from "react-json-view";
import Mbaas from "../../../provider/Mbaas";
import { isEmpty, omit, get } from "lodash";
import genRandomChar from "../../../utils/genRandomChar";
import InfoIcon from "@mui/icons-material/Info";
import withReactContent from "sweetalert2-react-content";

const useStyles = makeStyles({
  input: {
    marginBottom: "-20px",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
  },
  test: {
    '& ul li[aria-selected="true"]:after': {
      content: "'\\2713'",
      marginLeft: "auto",
    },
  },
});

const ToolbarCreate = () => {
  return (
    <Toolbar classes={useStyles()}>
      <SaveButton />
    </Toolbar>
  );
};

const ToolbarCsvDialog = () => {
  return <></>;
};

export const CreateFlashsale = ({ onCancel, ...props }) => {
  const classes = useStyles();

  const [optionItemGroup, setOptionItemGroup] = useState([]);
  const [optionItemKey, setOptionItemKey] = useState([]);

  const [selectedItemGroup, setSelectedItemGroup] = useState([]);
  const [selectedItemKey, setSelectedItemKey] = useState([]);

  const [optionTargetItemGroup, setOptionTargetItemGroup] = useState([]);
  const [optionTargetItemKey, setOptionTargetItemKey] = useState([]);

  const [selectedTargetItemGroup, setSelectedTargetItemGroup] = useState([]);
  const [selectedTargetItemKey, setSelectedTargetItemKey] = useState([]);

  const [firstRender, setFirstRender] = useState(true);

  // Add states for search text
  const [itemGroupSearchText, setItemGroupSearchText] = useState("");
  const [targetItemGroupSearchText, setTargetItemGroupSearchText] =
    useState("");

  const [specSubSx, setSpecSubSx] = useState(12);

  const [openCsvDialog, setOpenCsvDialog] = useState(false);
  const [fileCsv, setFileCsv] = useState("");
  const [uploadedFileCsv, setUploadedFileCsv] = useState("");
  const [specificSubscriber, setSpecificSubscriber] = useState([]);

  const [isNewSubs, setIsNewSubs] = useState(false);
  const [isProductiveSubs, setIsProductiveSubs] = useState(false);
  const [isComebackSubs, setIsComebackSubs] = useState(false);
  const [isBirthdaySubs, setIsBirthdaySubs] = useState(false);

  const [bonusCode, setBonusCode] = useState("");
  const [promoCode, setPromoCode] = useState("");
  const [urlOption, setUrlOption] = useState([]);
  const [selectedPlatform, setSelectedPlatform] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");

  const [showItemGroupError, setShowItemGroupError] = useState(false);
  const [showItemKeyError, setShowItemKeyError] = useState(false);
  const [showTargetItemGroupError, setShowTargetItemGroupError] =
    useState(false);
  const [showTargetItemKeyError, setShowTargetItemKeyError] = useState(false);
  const [showBonusCodeError, setShowBonusCodeError] = useState(false);
  const [showPromoCodeError, setShowPromoCodeError] = useState(false);

  const notify = useNotify();

  const handleCloseCsvDialog = () => {
    setOpenCsvDialog(false);
  };

  const handleOpenCsvDialog = () => {
    setOpenCsvDialog(true);
  };

  const handleGenerateRandomCode = ({
    field,
  }: {
    field: "BONUS_CODE" | "PROMO_CODE";
  }) => {
    const generatedCode = genRandomChar(10).toUpperCase();
    if (field === "PROMO_CODE") setPromoCode(generatedCode);
    if (field === "BONUS_CODE") setBonusCode(generatedCode);
  };

  const handleUploadCsv = () => {
    const reader = new FileReader();
    reader.onload = async ({ target }) => {
      const csv = Papa.parse(target.result, { header: true });
      const parsedData = csv?.data;
      const columns = parsedData
        .flat()
        .map((item) => item.phone)
        .filter((item) => item);
      if (!columns.length) {
        notify(`1st line in CSV file should be 'phone'!`, { type: "warning" });
        return;
      }
      setSpecificSubscriber(columns);
      setFileCsv(null);
      notify(`CSV file uploaded successfully!`);
    };
    reader.readAsText(fileCsv);
  };

  // Function to fetch item keys for specific item groups
  const fetchItemKeysForGroups = async (itemGroups) => {
    if (!itemGroups || itemGroups.length === 0) {
      return [];
    }

    try {
      // If only one item group, use simple filter
      if (itemGroups.length === 1) {
        const response = await dataProvider.getList("servicesProduct", {
          filter: {
            item_group: itemGroups[0].id,
          },
          pagination: { page: 1, perPage: 1000 },
          sort: {
            field: "label",
            order: "ASC",
          },
        });

        const items = response.data;
        const itemKeys = [...new Set(items)]
          .filter((u) => itemGroups.map((t) => t.id).includes(u.item_group))
          .map((v) => ({
            id: `${v.item_key} (${v.label})`,
            name: `${v.item_key} (${v.label})`,
          }));

        return itemKeys;
      } else {
        // For multiple item groups, fetch all and then filter locally
        // This ensures we get all items for all selected groups
        const response = await dataProvider.getList("servicesProduct", {
          filter: {
            item_group: itemGroups.map((group) => group.id),
          }, // Fetch all, then filter locally
          pagination: { page: 1, perPage: 1000 }, // Increased to ensure we get all data
          sort: {
            field: "label",
            order: "ASC",
          },
        });

        const items = response.data;
        const selectedGroupIds = itemGroups.map((t) => t.id);

        const itemKeys = [...new Set(items)]
          .filter((u) => selectedGroupIds.includes(u.item_group))
          .map((v) => ({
            id: `${v.item_key} (${v.label})`,
            name: `${v.item_key} (${v.label})`,
          }));

        return itemKeys;
      }
    } catch (error) {
      console.error("Error fetching item keys for groups:", error);
      return [];
    }
  };

  // Function to fetch item groups with optional search filter
  const fetchItemGroups = async (searchText = "") => {
    const filter = searchText.trim() ? { item_group: searchText.trim() } : {};

    try {
      const response = await dataProvider.getList("servicesProduct", {
        filter,
        pagination: { page: 1, perPage: 1000 },
        sort: {
          field: "label",
          order: "ASC",
        },
      });

      const items = response.data;
      const itemGroups = [...new Set(items)]
        ?.filter(
          (v, i, a) => a.findIndex((t) => t.item_group === v.item_group) === i
        )
        .filter(
          (x) => !["bpjs", "plnbill"].includes(x.item_group.toLowerCase())
        )
        .map((v) => ({
          id: v.item_group,
          name: v.item_group,
        }))
        .sort((a, b) => {
          const nameA = a.name.toUpperCase();
          const nameB = b.name.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });

      return { itemGroups, items };
    } catch (error) {
      console.error("Error fetching item groups:", error);
      return { itemGroups: [], items: [] };
    }
  };

  const uploadedCsv = async () => {
    let filename = `spec-subs-phone`;
    if (uploadedFileCsv !== "") filename = uploadedFileCsv;
    let jsonObject = [{ phone: "" }];
    if (specificSubscriber?.length) {
      jsonObject = specificSubscriber.map((phone) => {
        return { phone: phone };
      });
    }
    jsonExport(jsonObject, {}, (err: any, csv: any) => {
      downloadCSV(csv, filename);
    });
  };

  // Effect for fetching item groups with search functionality
  useEffect(() => {
    let haloTimeout = setTimeout(async () => {
      const { itemGroups } = await fetchItemGroups(itemGroupSearchText);
      setOptionItemGroup(itemGroups);
    }, 500); // Reduced timeout for better UX

    return () => clearTimeout(haloTimeout);
  }, [itemGroupSearchText]);

  // Separate effect for fetching item keys when selectedItemGroup changes
  useEffect(() => {
    const fetchItemKeys = async () => {
      console.log("selectedItemGroup changed:", selectedItemGroup);

      if (selectedItemGroup.length > 0) {
        console.log(
          "Fetching item keys for groups:",
          selectedItemGroup.map((g) => g.id)
        );
        const itemKeys = await fetchItemKeysForGroups(selectedItemGroup);
        console.log("Fetched item keys:", itemKeys.length, itemKeys);

        setOptionItemKey(itemKeys);
        !firstRender && setSelectedItemKey(itemKeys);
      } else {
        setOptionItemKey([]);
        setSelectedItemKey([]);
      }
    };

    fetchItemKeys();
  }, [selectedItemGroup, firstRender]);

  // Effect for fetching target item groups with search functionality
  useEffect(() => {
    let haloTimeout = setTimeout(async () => {
      const { itemGroups } = await fetchItemGroups(targetItemGroupSearchText);
      setOptionTargetItemGroup(itemGroups);
    }, 500); // Reduced timeout for better UX

    return () => clearTimeout(haloTimeout);
  }, [targetItemGroupSearchText]);

  // Separate effect for fetching target item keys when selectedTargetItemGroup changes
  useEffect(() => {
    const fetchTargetItemKeys = async () => {
      console.log("selectedTargetItemGroup changed:", selectedTargetItemGroup);

      if (selectedTargetItemGroup.length > 0) {
        console.log(
          "Fetching target item keys for groups:",
          selectedTargetItemGroup.map((g) => g.id)
        );
        const itemKeys = await fetchItemKeysForGroups(selectedTargetItemGroup);
        console.log("Fetched target item keys:", itemKeys.length, itemKeys);

        setOptionTargetItemKey(itemKeys);
        !firstRender && setSelectedTargetItemKey(itemKeys);
      } else {
        setOptionTargetItemKey([]);
        setSelectedTargetItemKey([]);
      }
    };

    fetchTargetItemKeys();
  }, [selectedTargetItemGroup, firstRender]);

  useEffect(() => {
    const close = (e) => {
      if (e.keyCode === 27) {
        onCancel();
      }
    };
    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, [onCancel]);

  const handleNotFound = () => {
    Swal.fire("Subscriber Not Found", "", "error");
  };

  const redirect = useRedirect();
  const refresh = useRefresh();

  const onSubmitHandler = async (data) => {
    let configsSpecSubs = [] as Array<{
      id: string;
      name: string;
      phone: string;
    }>;

    if (
      data.configs.specific_subscriber.status === true &&
      specificSubscriber?.length
    ) {
      const getSubs = await dataProvider.getList("subscribers", {
        filter: {
          phone: specificSubscriber,
        },
        sort: {
          field: "phone",
          order: "asc",
        },
        pagination: {
          page: 1,
          perPage: 999999,
        },
      });
      configsSpecSubs = getSubs.data.map((subs) => {
        return { id: subs.id, name: subs.name, phone: subs.phone };
      });
      if (
        !configsSpecSubs.length ||
        specificSubscriber.length !== configsSpecSubs.length
      ) {
        return handleNotFound();
      }
    }

    if (
      data.configs.specific_subscriber.status === true &&
      !specificSubscriber?.length
    ) {
      data.configs.specific_subscriber.status = false;
    }

    // Validate cashback amount/percentage against promotion value
    if (data.cashback.status) {
      const promotionValue = Number(data.value);
      if (Number.isNaN(promotionValue) || promotionValue <= 0) {
        Swal.fire(
          "Invalid Promotion Value",
          "Please enter a valid promotion value",
          "error"
        );
        return;
      }
      if (data.cashback.type === "PERCENTAGE") {
        const cashbackPercentage = Number(data.cashback.percentage);
        // For percentage, validate it's between 0 and 1 (e.g., 0.07 for 7%, 0.5 for 50%)
        if (cashbackPercentage < 0 || cashbackPercentage > 1) {
          Swal.fire(
            "Invalid Cashback",
            "Cashback percentage must be between 0 and 1 (e.g., 0.07 for 7%, 0.5 for 50%)",
            "error"
          );
          return;
        }
      } else if (data.cashback.type === "WHOLE") {
        const cashbackAmount = Number(data.cashback.amount);
        if (cashbackAmount > promotionValue) {
          Swal.fire(
            "Invalid Cashback",
            "Cashback amount must be less than or equal to the promotion value",
            "error"
          );
          return;
        }
      }
    }

    const isFieldEmpty = (str) => {
      return !str || str.trim() === "";
    };

    if (selectedItemGroup.length === 0) {
      notify("Item Groups is required", { type: "warning" });
      setShowItemGroupError(true);
      return;
    } else {
      setShowItemGroupError(false);
    }

    if (selectedItemKey.length === 0) {
      notify("Item Keys is required", { type: "warning" });
      setShowItemKeyError(true);
      return;
    } else {
      setShowItemKeyError(false);
    }

    if (data.is_bonus && !data.bonus?.auto_bonus) {
      if (selectedTargetItemGroup.length === 0) {
        notify("Target Item Groups is required", { type: "warning" });
        setShowTargetItemGroupError(true);
        return;
      } else {
        setShowTargetItemGroupError(false);
      }

      if (selectedTargetItemKey.length === 0) {
        notify("Target Item Keys is required", { type: "warning" });
        setShowTargetItemKeyError(true);
        return;
      } else {
        setShowTargetItemKeyError(false);
      }

      if (isFieldEmpty(bonusCode)) {
        notify("Bonus Code is required and cannot be empty", {
          type: "warning",
        });
        setShowBonusCodeError(true);
        return;
      } else {
        setShowBonusCodeError(false);
      }
    }

    if (data.promo_code?.status) {
      if (isFieldEmpty(promoCode)) {
        notify("Promo Code is required and cannot be empty", {
          type: "warning",
        });
        setShowPromoCodeError(true);
        return;
      } else {
        setShowPromoCodeError(false);
      }
    }

    await dataProvider
      .create("promotionsFlashsale", {
        data: {
          ...omit(data, ["bonus", "is_bonus", "cashback", "promo_code", "platforms"]),
          value: Number(data.value),
          configs: {
            ...{
              ...data.configs,
              ever_productive_subscriber: isProductiveSubs,
              new_subscriber_only: isNewSubs,
              comeback_subscriber: isComebackSubs,
              birthday_subscriber: isBirthdaySubs,
              cashback: {
                status:
                  (data.cashback.percentage || data.cashback.amount) &&
                  data.cashback.unit
                    ? data.cashback.status
                    : false,
                percentage: data.cashback.percentage
                  ? `${data.cashback.percentage}`
                  : "",
                amount: data.cashback.amount ? data.cashback.amount : "",
                unit: data.cashback.unit || "",
              },
              promo_code: {
                status: data.promo_code.status,
                ...(promoCode ? { code: promoCode } : { code: "" }),
              },
            },
            platform: data.platforms,
            specific_subscriber: {
              status: data.configs.specific_subscriber.status,
              ...(configsSpecSubs.length
                ? { subscribers: configsSpecSubs }
                : {}),
            },
          },
          items: {
            item_groups: selectedItemGroup.map((x) => {
              return x.id;
            }),
            item_keys: selectedItemKey.map((x) => {
              return x.id.split(" (")[0];
            }),
            bonus: {
              item_groups: selectedTargetItemGroup.map((x) => {
                return x.id;
              }),
              item_keys: selectedTargetItemKey.map((x) => {
                return x.id.split(" (")[0];
              }),
              product_name: data.bonus?.product_name || "",
              code: data.bonus?.auto_bonus ? "AUTO" : bonusCode || "",
              url: data.bonus?.url || "",
              auto_bonus: data.bonus?.auto_bonus,
            },
          },
        },
      })
      .then(() => {
        notify("ra.notification.created", {
          type: "info",
          messageArgs: { smart_count: 1 },
          undoable: true,
        });
        redirect(`/promotions/flashsale`);
        refresh();
        Swal.fire("Success!", "", "success");
      });
  };

  useEffect(() => {
    const getUrlList = async () => {
      if (isEmpty(selectedCountry) && isEmpty(selectedPlatform)) {
        return setUrlOption([]);
      }
      const resp = await Mbaas.client.invokeApi("console-webview-link-list", {
        country: selectedCountry,
        platform: selectedPlatform,
      });

      if (resp.data) {
        setUrlOption(resp.data.map((m) => ({ id: m.url, name: m.label })));
      } else {
        setUrlOption([]);
      }
    };
    getUrlList();
  }, [selectedCountry, selectedPlatform]);

  return (
    <Create resource="promotionsFlashsale" title=" &rsaquo; Create" {...props}>
      <Dialog open={openCsvDialog} onClose={handleCloseCsvDialog}>
        <DialogTitle>CSV File</DialogTitle>
        <DialogContent dividers>
          <SimpleForm toolbar={<ToolbarCsvDialog />}>
            <Button
              startIcon={<DescriptionIcon />}
              onClick={uploadedCsv}
              label={
                specificSubscriber.length
                  ? "See Uploaded CSV"
                  : "Download Master CSV"
              }
              variant="outlined"
            />
            <br />
            {specificSubscriber.length ? (
              <DialogContentText>
                <ReactJson
                  src={specificSubscriber || []}
                  collapsed={true}
                  enableClipboard={false}
                  displayDataTypes={false}
                  displayObjectSize={true}
                  groupArraysAfterLength={10}
                  name={false}
                />
                <br />
              </DialogContentText>
            ) : (
              ""
            )}
            <FileInput
              source="files"
              options={{ multiple: false }}
              onChange={(e) => {
                setFileCsv(e);
                const filenameArray = e?.name.split(".");
                filenameArray?.pop();
                setUploadedFileCsv(filenameArray?.join("."));
              }}
            >
              <FileField source="src" title="title" />
            </FileInput>
          </SimpleForm>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseCsvDialog}>Close</Button>
          <Button
            onClick={handleUploadCsv}
            startIcon={<UploadFileIcon />}
            label="Upload"
            autoFocus
            disabled={!fileCsv}
          />
        </DialogActions>
      </Dialog>
      <Box pt={5} width={{ xs: "100vW", sm: 600 }} mt={{ xs: 2, sm: 1 }}>
        <Stack
          direction="row"
          p={0}
          sx={{ position: "absolute", right: 0, top: 10, zIndex: 100 }}
        >
          <IconButton onClick={onCancel} size="small">
            <CloseIcon />
          </IconButton>
        </Stack>
        <SimpleForm
          // sx={{ width: "100%" }}
          onSubmit={onSubmitHandler}
          toolbar={<ToolbarCreate />}
        >
          <div className={classes.root}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <SelectInput
                  label="Country"
                  source="country"
                  fullWidth
                  value={selectedCountry}
                  validate={required()}
                  choices={[
                    { id: "HK", name: "Hongkong" },
                    { id: "ID", name: "Indonesia" },
                    { id: "TW", name: "Taiwan" },
                    { id: "MY", name: "Malaysia" },
                  ]}
                  data-testid="input-country"
                  onChange={(e) => {
                    setSelectedCountry(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <AutocompleteArrayInput
                  label="Platform"
                  source="platforms"
                  fullWidth
                  validate={required()}
                  value={selectedPlatform}
                  onChange={(value) => {
                    setSelectedPlatform(value);
                    if(!value.includes("GHK")){
                      setIsBirthdaySubs(false);
                    }
                  }}
                  choices={[
                    { id: "M21", name: "M21" },
                    { id: "G2", name: "G2" },
                    { id: "GHK", name: "GHK" },
                  ]}
                  optionText="name"
                  optionsValue="id"
                  data-testid="input-platform"
                />
              </Grid>
              <FormDataConsumer>
                {({ formData }) => {
                  const autoBonus = get(formData, "bonus.auto_bonus");
                  return (
                    <Grid item xs={12}>
                      <ItemGroupAutocomplete
                        label="Item Groups"
                        source="items.item_groups"
                        validate={required()}
                        option={optionItemGroup}
                        selectedItemGroup={selectedItemGroup}
                        setSelectedTargetItemGroup={setSelectedTargetItemGroup}
                        setSelectedItemGroup={setSelectedItemGroup}
                        setSelectedItemKey={setSelectedItemKey}
                        firstRender={firstRender}
                        setFirstRender={setFirstRender}
                        autoBonus={autoBonus}
                        error={showItemGroupError}
                        helperText={
                          showItemGroupError ? "Item Groups is required" : ""
                        }
                        onInputChange={setItemGroupSearchText}
                      />
                    </Grid>
                  );
                }}
              </FormDataConsumer>
              <Grid item xs={12}>
                <ItemKeyAutocomplete
                  label="Item Keys"
                  source="items.item_keys"
                  validate={required()}
                  option={optionItemKey}
                  selectedItemKey={selectedItemKey}
                  setSelectedItemKey={setSelectedItemKey}
                  firstRender={firstRender}
                  setFirstRender={setFirstRender}
                  data-testid="input-item-keys"
                  error={showItemKeyError}
                  helperText={showItemKeyError ? "Item Keys is required" : ""}
                />
              </Grid>
              <Grid item sm={12}>
                <Box sx={{ display: "flex" }}>
                  <h5>Promotion Features Descriptions</h5>
                  <MuiButton
                    onClick={() => alertInformation("PROMOTION_FEATURES")}
                    style={{ minWidth: "auto", padding: 0, marginLeft: "10px" }}
                  >
                    <InfoIcon />
                  </MuiButton>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <BooleanInput
                  fullWidth
                  source="promo_code.status"
                  data-testid="promo_code"
                  label="Add Promo Code?"
                  helperText={false}
                />
              </Grid>
              <FormDataConsumer>
                {({ formData }) => {
                  const isPromoCode = get(formData, "promo_code.status");
                  if (isPromoCode) {
                    return (
                      <>
                        <Grid item xs={8} style={{ paddingTop: 0 }}>
                          <MuiTextField
                            fullWidth
                            value={promoCode}
                            label="Promo Code"
                            defaultValue={promoCode}
                            error={showPromoCodeError}
                            helperText={
                              showPromoCodeError ? "Promo Code is required" : ""
                            }
                            onChange={(e) => setPromoCode(e.target.value)}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          sx={{ display: "flex" }}
                          style={{ paddingTop: 0 }}
                        >
                          <Button
                            onClick={() =>
                              handleGenerateRandomCode({ field: "PROMO_CODE" })
                            }
                            label="Generate"
                            sx={{
                              alignContent: "center",
                              color: "white",
                              backgroundColor: "#0488d1",
                              margin: "8px 0px 3px 0px",
                              padding: "0px 10px 0px 10px",
                              ":hover": {
                                color: "white",
                                backgroundColor: "#0488d1",
                              },
                            }}
                          />
                        </Grid>
                      </>
                    );
                  }
                  return null;
                }}
              </FormDataConsumer>
              <Grid item xs={12}>
                <BooleanInput
                  fullWidth
                  source="is_bonus"
                  data-testid="is_bonus"
                  label="Add Bonus?"
                />
              </Grid>
              <FormDataConsumer>
                {({ formData }) => {
                  const isBonus = get(formData, "is_bonus");
                  const autoBonus = get(formData, "bonus.auto_bonus");
                  if (isBonus) {
                    return (
                      <>
                        <Grid item xs={12}>
                          <BooleanInput
                            fullWidth
                            source="bonus.auto_bonus"
                            label="Auto Bonus?"
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedTargetItemGroup(selectedItemGroup);
                              }
                            }}
                          />
                        </Grid>
                        <FormDataConsumer>
                          {({ formData }) => {
                            const autoBonus =
                              get(formData, "bonus.auto_bonus") || false;
                            if (!autoBonus) {
                              return (
                                <Grid item xs={12}>
                                  <Typography variant="h5">
                                    Bonus Item
                                  </Typography>
                                </Grid>
                              );
                            } else {
                              return (
                                <Grid item xs={12}>
                                  <Typography variant="h5">
                                    Auto Bonus Item
                                  </Typography>
                                </Grid>
                              );
                            }
                          }}
                        </FormDataConsumer>
                        <Grid item xs={12}>
                          <ItemGroupTargetAutocomplete
                            label="Target Item Groups"
                            source="bonus.item_groups"
                            validate={required()}
                            option={optionTargetItemGroup}
                            selectedItemGroup={selectedItemGroup}
                            selectedTargetItemGroup={selectedTargetItemGroup}
                            setSelectedTargetItemGroup={
                              setSelectedTargetItemGroup
                            }
                            setSelectedItemKey={setSelectedTargetItemKey}
                            firstRender={firstRender}
                            className={classes.input}
                            setFirstRender={setFirstRender}
                            disabled={autoBonus}
                            error={showTargetItemGroupError}
                            helperText={
                              showTargetItemGroupError
                                ? "Target Item Groups is required"
                                : ""
                            }
                            onInputChange={setTargetItemGroupSearchText}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <ItemKeyAutocomplete
                            label="Target Item Keys"
                            source="bonus.item_keys"
                            validate={required()}
                            option={optionTargetItemKey}
                            selectedItemKey={selectedTargetItemKey}
                            setSelectedItemKey={setSelectedTargetItemKey}
                            firstRender={firstRender}
                            setFirstRender={setFirstRender}
                            className={classes.input}
                            data-testid="input-bonus-item-keys"
                            error={showTargetItemKeyError}
                            helperText={
                              showTargetItemKeyError
                                ? "Target Item Keys is required"
                                : ""
                            }
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextInput
                            validate={required()}
                            fullWidth
                            className={classes.input}
                            source="bonus.product_name"
                            data-testid="input-bonus-product-name"
                            label="Product Name"
                          />
                        </Grid>
                        <FormDataConsumer>
                          {({ formData }) => {
                            const autoBonus =
                              get(formData, "bonus.auto_bonus") || false;
                            if (!autoBonus)
                              return (
                                <>
                                  <Grid item xs={8}>
                                    <BonusCodeInput
                                      source="bonus.code"
                                      value={bonusCode}
                                      setBonusCode={setBonusCode}
                                      error={showBonusCodeError}
                                      helperText={
                                        showBonusCodeError
                                          ? "Bonus Code is required"
                                          : ""
                                      }
                                    />
                                  </Grid>
                                  <Grid item xs={4} sx={{ display: "flex" }}>
                                    <Button
                                      onClick={() =>
                                        handleGenerateRandomCode({
                                          field: "BONUS_CODE",
                                        })
                                      }
                                      label="Generate"
                                      sx={{
                                        alignContent: "center",
                                        color: "white",
                                        backgroundColor: "#0488d1",
                                        margin: "8px 0px 3px 0px",
                                        padding: "0px 10px 0px 10px",
                                        ":hover": {
                                          color: "white",
                                          backgroundColor: "#0488d1",
                                        },
                                      }}
                                    />
                                  </Grid>
                                </>
                              );
                          }}
                        </FormDataConsumer>
                        <Grid item xs={12}>
                          <AutocompleteInput
                            label="Url"
                            source="bonus.url"
                            fullWidth
                            choices={urlOption}
                            validate={required()}
                          />
                        </Grid>
                      </>
                    );
                  }
                  return null;
                }}
              </FormDataConsumer>
              <Grid item xs={12}>
                <BooleanInput
                  fullWidth
                  source="cashback.status"
                  label="Add Cashback?"
                />
              </Grid>
              <FormDataConsumer>
                {({ formData }) => {
                  const isCashback = get(formData, "cashback.status");
                  const cashBackType = get(formData, "cashback.type");
                  const cashBackLabel =
                    cashBackType === "PERCENTAGE"
                      ? "Percentage (example: 0.5)"
                      : "Type whole amount for cashback";

                  if (isCashback) {
                    return (
                      <>
                        <Grid item xs={12}>
                          <Typography variant="h5">Cashback Item</Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <SelectInput
                            label="Type"
                            source="cashback.type"
                            fullWidth
                            defaultValue="WHOLE"
                            choices={[
                              { id: "WHOLE", name: "Whole amount" },
                              { id: "PERCENTAGE", name: "Percentage" },
                            ]}
                            validate={required()}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextInput
                            fullWidth
                            className={classes.input}
                            source={
                              cashBackType === "PERCENTAGE"
                                ? "cashback.percentage"
                                : "cashback.amount"
                            }
                            label={cashBackLabel}
                            inputProps={{
                              pattern: String.raw`^[0-9]*(\.[0-9]*)?$`,
                            }}
                            validate={required()}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <SelectInput
                            label="Unit"
                            source="cashback.unit"
                            fullWidth
                            choices={[
                              { id: "COIN", name: "Coin ( Balance )" },
                              { id: "POINT", name: "Point" },
                            ]}
                            validate={required()}
                          />
                        </Grid>
                      </>
                    );
                  }
                  return null;
                }}
              </FormDataConsumer>
              <Grid item sm={12}>
                <Box sx={{ display: "flex" }}>
                  <h5>Target Promotion Options</h5>
                  <MuiButton
                    onClick={() => alertInformation("TARGET_PROMOTION")}
                    style={{ minWidth: "auto", padding: 0, marginLeft: "10px" }}
                  >
                    <InfoIcon />
                  </MuiButton>
                </Box>
              </Grid>
              <FormDataConsumer>
                {({ formData }) => {
                  const platformArray = get(formData, "platforms", []);
                  const isPlatformGHK = platformArray.length === 1 && platformArray[0] === "GHK";

                  if (isPlatformGHK) {
                    return (
                      <Grid item xs={6}>
                        <BooleanInput
                          source="configs.birthday_subscriber"
                          label="Birthday Subs"
                          data-testid="input-birthday-subs"
                          checked={isBirthdaySubs}
                          onChange={(e) => {
                            setIsBirthdaySubs(e.target.checked);
                          }}
                        />
                      </Grid>
                    );
                  }
                  return null;
                }}
              </FormDataConsumer>
              <Grid item xs={6}>
                <BooleanInput
                  source="configs.once_per_target"
                  label="1x / MSISDN?"
                  data-testid="input-once-per-target"
                />
              </Grid>
              <Grid item xs={6}>
                <BooleanInput
                  source="configs.new_subscriber_only"
                  label="For New Subs. Only?"
                  title="Subs. / MSISN without success transactions before this promo is created"
                  data-testid="input-new-subscriber-only"
                  checked={isNewSubs}
                  onChange={(e) => {
                    setIsNewSubs(e.target.checked);
                    setIsProductiveSubs(false);
                    setIsComebackSubs(false);
                  }}
                />
              </Grid>
              <Grid item xs={specSubSx}>
                <BooleanInput
                  source="configs.specific_subscriber.status"
                  label="For Specific Subs.?"
                  title="Is applied for Specific Subs.?"
                  data-testid="input-specific-subscriber-status"
                />
              </Grid>
              <FormDataConsumer subscription={{ values: true }}>
                {({ formData, ...rest }) => {
                  if (formData?.configs?.specific_subscriber?.status) {
                    setSpecSubSx(6);
                    return (
                      <Grid item xs={6}>
                        <Button
                          label="CSV File"
                          data-testid="csv-file"
                          variant="contained"
                          onClick={handleOpenCsvDialog}
                        >
                          <PostAddIcon />
                        </Button>
                      </Grid>
                    );
                  } else {
                    setSpecSubSx(12);
                  }
                }}
              </FormDataConsumer>
              <Grid item xs={6}>
                <BooleanInput
                  source="configs.ever_productive_subscriber"
                  label="For Ever Productive Subs. ?"
                  title="Subs. who have done their first purchase"
                  data-testid="input-ever-productive-subscriber"
                  checked={isProductiveSubs}
                  onChange={(e) => {
                    setIsProductiveSubs(e.target.checked);
                    setIsNewSubs(false);
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <BooleanInput
                  source="configs.registered_subscriber"
                  label="For Registered Subs. ?"
                  title="Subs. who has registered"
                  data-testid="input-registered-subscriber"
                />
              </Grid>
              <Grid item xs={12}>
                <BooleanInput
                  source="configs.comeback_subscriber"
                  label="For Comeback Subs. ?"
                  title="Subs. who has not purchase more than 30 days"
                  data-testid="input-comeback-subscriber"
                  checked={isComebackSubs}
                  onChange={(e) => {
                    setIsComebackSubs(e.target.checked);
                    setIsNewSubs(false);
                  }}
                />
              </Grid>
              <Grid item sm={12}>
                <Box sx={{ display: "flex" }}>
                  <h5>Promotion Usage</h5>
                  <MuiButton
                    onClick={() => alertInformation("PROMOTION_USAGE")}
                    style={{ minWidth: "auto", padding: 0, marginLeft: "10px" }}
                  >
                    <InfoIcon />
                  </MuiButton>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <TextInput
                  fullWidth
                  className={classes.input}
                  source="configs.max_usage_per_subscriber"
                  data-testid="input-max-usage-per-subscriber"
                  label="Max Usage per Subs."
                  validate={required()}
                />
              </Grid>
              <Grid item xs={6}>
                <TextInput
                  fullWidth
                  className={classes.input}
                  source="configs.total_usage"
                  data-testid="input-max-total-usage"
                  label="Max Total Usage"
                  validate={required()}
                />
              </Grid>
              <Grid item xs={12}>
                <TextInput
                  fullWidth
                  className={classes.input}
                  source="value"
                  data-testid="input-value"
                  label="Value"
                  validate={required()}
                />
              </Grid>
              <Grid item xs={6}>
                <DateTimeInput
                  label="Valid From"
                  source="start"
                  fullWidth
                  className={classes.input}
                  validate={[required()]}
                  data-testid="input-start"
                />
              </Grid>
              <Grid item xs={6}>
                <DateTimeInput
                  label="Valid Until"
                  source="end"
                  fullWidth
                  className={classes.input}
                  validate={[required()]}
                  data-testid="input-end"
                />
              </Grid>
            </Grid>
          </div>
        </SimpleForm>
      </Box>
    </Create>
  );
};

const ItemGroupAutocomplete = ({
  setSelectedItemGroup,
  error,
  helperText,
  onInputChange,
  ...props
}) => {
  const classes = useStyles();

  return (
    <Autocomplete
      fullWidth
      multiple
      id="tags-standard"
      disableCloseOnSelect={true}
      options={props.option}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      value={props.selectedItemGroup}
      style={{ marginBottom: "32px" }}
      onInputChange={(_, value) => {
        if (onInputChange) {
          onInputChange(value);
        }
      }}
      onChange={(_, v) => {
        // onChange(v)
        props.setFirstRender(false);
        setSelectedItemGroup(v);
        props.setSelectedItemKey([]);
        if (props.autoBonus) {
          props.setSelectedTargetItemGroup(v);
        }
      }}
      required={props.validate.isRequired}
      PaperComponent={({ children }) => (
        <Paper className={classes.test}>{children}</Paper>
      )}
      renderInput={(params) => (
        <MuiTextField
          {...params}
          variant="filled"
          label={props.label}
          placeholder={`select Item Group`}
          data-testid="input-item-groups"
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};

const ItemGroupTargetAutocomplete = ({
  setSelectedTargetItemGroup,
  error,
  helperText,
  onInputChange,
  ...props
}) => {
  const classes = useStyles();

  return (
    <Autocomplete
      fullWidth
      multiple
      id="tags-standard"
      disableCloseOnSelect={true}
      options={props.option}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      value={props.selectedTargetItemGroup}
      style={{ marginBottom: "32px" }}
      disabled={props.disabled}
      onInputChange={(_, value) => {
        if (onInputChange) {
          onInputChange(value);
        }
      }}
      onChange={(_, v) => {
        // onChange(v)
        props.setFirstRender(false);
        setSelectedTargetItemGroup(v);
        props.setSelectedItemKey([]);
      }}
      required={props.validate.isRequired}
      PaperComponent={({ children }) => (
        <Paper className={classes.test}>{children}</Paper>
      )}
      renderInput={(params) => (
        <MuiTextField
          {...params}
          variant="filled"
          label={props.label}
          placeholder={`select Item Group`}
          data-testid="input-item-groups"
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};

const BonusCodeInput = ({ setBonusCode, error, helperText, ...props }) => {
  return (
    <MuiTextField
      fullWidth
      value={props.value}
      label="Bonus Code"
      defaultValue={props.value}
      error={error}
      helperText={helperText}
      onChange={(e) => setBonusCode(e.target.value)}
    />
  );
};

const ItemKeyAutocomplete = ({
  setSelectedItemKey,
  error,
  helperText,
  ...props
}) => {
  const classes = useStyles();

  return (
    <Autocomplete
      fullWidth
      multiple
      id="tags-standard"
      disableCloseOnSelect={true}
      options={props.option}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      value={props.selectedItemKey}
      style={{ marginBottom: "32px" }}
      onChange={(_, v) => {
        // onChange(v)
        setSelectedItemKey(v);
      }}
      required={props.validate.isRequired}
      PaperComponent={({ children }) => (
        <Paper className={classes.test}>{children}</Paper>
      )}
      renderInput={(params) => (
        <MuiTextField
          {...params}
          variant="filled"
          label={props.label}
          placeholder={`select Item Key`}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};

const alertInformation = (type: string) => {
  const MySwal = withReactContent(Swal);
  let promptMessage = ``;
  switch (type) {
    case "PROMOTION_FEATURES":
      promptMessage = `
      <p><strong>Add Bonus:</strong> This option is used to add a bonus to a promotion that has been set up.</p>
      <p><strong>Add Cashback:</strong> This option is used to configure cashback settings within a promotion.</p>
      `;
      break;
    case "TARGET_PROMOTION":
      promptMessage = `
      <p><strong>1x/MSISDN:</strong> The promotion is applicable only once per MSISDN (mobile subscriber number) for a single product.</p>
      <p><strong>For New Subscribers Only:</strong> The promotion targets only new subscribers (customers who have never completed a successful transaction).</p>
      <p><strong>For Specific Subscribers:</strong> The promotion is targeted at specific subscriber numbers that are manually uploaded through a CSV file.</p>
      <p><strong>For Registered Subscribers:</strong> The promotion applies only to subscribers who are already registered.</p>
      <p><strong>For Ever Productive Subscribers:</strong> The promotion is for customers who have completed at least one SUCCESS transaction since the release of the M21 app. There is no minimum transaction amount required.</p>
      <p><strong>For Comeback Subscribers:</strong> The promotion targets customers who have been inactive for over 30 days and then become active again.</p>
      `;
      break;
    case "PROMOTION_USAGE":
      promptMessage = `
      <p><strong>Max Usage per Subs.:</strong> The maximum number of times a promotion can be used by each subscriber.</p>
      <p><strong>Max Total Usage:</strong> The total maximum number of times the promotion can be used by all subscribers combined.</p>
      <p><strong>Value:</strong> The price of the product in HKD (Hong Kong Dollars).</p>
      `;
      break;
  }
  MySwal.fire({
    target: document.getElementById("history-modal"),
    title: `Information Detail`,
    html: (
      <Box
        sx={{ textAlign: "left" }}
        dangerouslySetInnerHTML={{ __html: promptMessage }}
        id="boxmessage"
      ></Box>
    ),
  });
};
